export const COMMUNITY_POST_STATUS = {
  PUBLISHED: "PUBLISHED",
  BANNED: "BANNED",
  HIDDEN: "HIDDEN",
};

export const COMMUNITY_POST_TYPES = {
  FREE: "FREE",
  REVIEW: "REVIEW",
  SURVEY: "SURVEY",
};
